import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { Add } from '@volkswagen-onehub/icons-core';
import * as React from 'react';
import styled from 'styled-components';
import { BonusHelper } from '../../../helpers/BonuesHelper';
import { Bonus, CarouselModeEnum } from '@esportal/portal-service';
import { PortalContext } from '../../../context/PortalContext';
import { useDisclaimers } from '../../../context/disclaimers-context';

const DivFlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`;

const BonusCarInfo = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 16px;
	left: 16px;
	padding: 4px 4px;
	border-radius: 18px;
	border: 1px solid #00b0f0;
	background-color: #ffffff;
`;

const BonusGetActionCtr = styled.div<{ avaliable?: boolean }>`
	visibility: ${(props) => (props.avaliable ? 'visible' : 'hidden')};
	position: absolute;
	right: 5%;
	margin-top: -25px;
`;

const CTAStyled = styled(CTA)`
	width: 40px;
	height: 40px;
	min-width: 40px;
	min-height: 40px;

	& svg {
		width: 20px;
		height: 20px;
	}

	@media screen and (min-width: 560px) and (max-width: 959px) {
		width: 48px;
		height: 48px;
		min-width: 48px;
		min-height: 48px;

		& svg {
			width: 24px;
			height: 24px;
		}
	}

	@media screen and (min-width: 960px) {
		width: 56px;
		height: 56px;
		min-width: 56px;
		min-height: 56px;

		& svg {
			width: 32px;
			height: 32px;
		}
	}
`;

const BonusDescCtr = styled.div<{
	avaliable?: boolean;
}>`
	opacity: ${(props) => (props.avaliable ? '1' : '0.6')};
`;

const StatusIndicator = styled.div<{ status: string }>`
	background: ${(props: { status: string }) => props.status};
	border-radius: 50%;
	width: 16px;
	height: 16px;
`;

const StyledReferenceBadge = styled(ReferenceBadge)`
	vertical-align: top;
	&::before {
		content: none;
	}
`;

export const BonusDescription: React.FC<{
	bonus: Bonus;
	shouldDisplayGetButton: boolean;
	carouselMode: CarouselModeEnum;
	showButton?: boolean;
}> = ({ bonus, shouldDisplayGetButton, showButton = true }) => {
	const { portalService } = React.useContext(PortalContext);

	const bonusVehicle = bonus.frame
		? portalService.getVehicleByFrame(bonus.frame).getValue()?.comercialDenomination
		: '';

	const { findBadge } = useDisclaimers();
	const badge = findBadge(bonus.legalText);

	return (
		<DivFlexColumn>
			{bonus.frame && (
				<BonusCarInfo>
					<Text appearance={TokenTextAppearance.label100} bold>
						{bonusVehicle}
					</Text>
				</BonusCarInfo>
			)}

			{showButton && (
				<BonusGetActionCtr avaliable={shouldDisplayGetButton}>
					<CTAStyled
						tag="button"
						emphasis="nbab"
						aria-label="clickBonus"
						icon={<Add variant="default" aria-hidden />}
					/>
				</BonusGetActionCtr>
			)}

			<BonusDescCtr avaliable={shouldDisplayGetButton}>
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0200,
						right: ContainerPadding.dynamic0100,
						bottom: ContainerPadding.dynamic0130,
						left: ContainerPadding.dynamic0100,
					}}
				>
					<Container>
						<Text
							appearance={TokenTextAppearance.headline300}
							textAlign={TextAlignment.start}
							color={TokenTextColor.primary}
						>
							{BonusHelper.buildLiteralMarkdownElement(bonus.title)}{' '}
							{badge && <StyledReferenceBadge>{badge.replace(/\.$/, '')}</StyledReferenceBadge>}
						</Text>
					</Container>

					<Container
						padding={{
							top: ContainerPadding.dynamic0100,
						}}
						wrap={'never'}
						gutter={ContainerGutter.static100}
						verticalAlign={'center'}
						shrinkContent
					>
						<Container
							padding={{
								right: ContainerPadding.static100,
							}}
						>
							<StatusIndicator status={BonusHelper.getBonusStatusColor(bonus.status)} />
						</Container>

						<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.inherit}>
							{BonusHelper.getValidityMessage(bonus.status, bonus.dateExpiration, bonus.dateEnjoyed)}
						</Text>
					</Container>
				</Container>
			</BonusDescCtr>
		</DivFlexColumn>
	);
};
